import { render, staticRenderFns } from "./SendOrderDeleteRecordToolbar.vue?vue&type=template&id=c417b2ee&"
import script from "./SendOrderDeleteRecordToolbar.vue?vue&type=script&lang=js&"
export * from "./SendOrderDeleteRecordToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SendOrderDeleteRecordToolbar.vue"
export default component.exports